export interface Therapy extends WithPRN {
    id: string;
    patient_id: string;
    description: string;
    drug: string;
    dose: string;
    administration_route: string;
    start_at: Date;
    stop_at: Date;
    previous_stop_at?: Date;
    created_at: Date;
    updated_at: Date;
    taken_in_time: number;
    taken_not_in_time: number;
    not_taken: number;
    scheme?: TherapyScheme
}

export interface Intake {
    id: number;
    therapy_id: string;
    date: string;
    time: string;
    status: IntakeStatus;
    created_at: string;
    updated_at: string;
    drug: string;
}

export interface TherapyStats {
    therapy_id: string
    taken_in_time: number
    taken_not_in_time: number
    not_taken: number
    waiting_response: number
  }

export enum IntakeStatus {
    waiting = 0,
    taken_in_time = 1,
    taken_not_in_time = 2,
    not_taken = 3,
}

export interface TherapyScheme extends WithPRN {
    id: string,
    name: string,
    drug: string,
    description: string,
    administration_route: string,
    default_dose: string,
    class?: string,
    doses?: string[],
    min_duration: string,
    default_duration: string,
    rules: TherapySchemeRule[]
}
export interface WithPRN {
    is_prn: boolean,
}

export interface TherapySchemeRule {
    from_day: Date,
    to_day: Date,
    intake_per_day: number,
    interval_hours?: number,
    times: string[]
}

export interface TherapyStatistics {
    range_type: TherapiesStatisticsRangeType,
    ranges: TherapyTrend[]
}

export type TherapiesStatisticsRangeType = 'week' | 'month' | 'day' | 'year';

export interface TherapyTrend {
    range: number,
    range_start: Date,
    range_end: Date,
    not_taken: number,
    taken: number,
    in_time: number,
    not_in_time: number,
    waiting_response: number,
    adherence: number,
    drug: string,
    therapy_id: string,
}